import { render, staticRenderFns } from "./ManagementBannersEdit.vue?vue&type=template&id=2e63adee&"
import script from "./ManagementBannersEdit.vue?vue&type=script&lang=js&"
export * from "./ManagementBannersEdit.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/banners.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports